/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Chunk {
  /**
   * Generate values from an array or record
   *
   * @public
   * @function f1.chunk
   * @param size length of each chunk, which is an array
   * @param arr the array to chunk
   * @example
   *
   * ```ts
   * f1.chunk(2, [1, 2, 3, 4, 5]) => [[1, 2], [3, 4], [5]]
   * f1.chunk(2, [1, 2, 3, 4, 5, 6]) => [[1, 2], [3, 4], [5, 6]]
   * ```
   *
   */
  <T>(size: number, arr: T[]): T[][];
  <T>(size: number): (arr: T[]) => T[][];
}

/**
 * @see Chunk
 */
export default <T>(size: number, arr: T[]): T[][] => {
  return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));
};
